import {forwardRef, useEffect, useLayoutEffect, useState} from "react";
import {imgPathPerfix, isInDraw} from "@/utils";
import {ipcInvoke, ipcOn, ipcSend} from "@/common/ipc";
import {recvMessage} from "@/common/event";
import emitter, {
    EVENT_CHANGE_THEME,
    EVENT_REFRESH_USER_IFNO,
    EVENT_WINDOW_BAR_VISIBLE, KEY_IS_MAX_SIZE,
    SYS_CONFIG_KEY_THEME,
    THEME_DARK, THEME_LIGHT
} from "@/Const";
import {APP_WEB, APP_WEB_WWW, isWeb} from "@/electron_interactive";
import {t} from "i18next";
import {isInSingleFloatWindow, isMac} from "@/Utility";


const TitleBar = forwardRef((props:{title:string,isDark:boolean,fromPage:string}, ref)=>{
    const [title,setTitle] = useState('Home');
    const [isMaxSize,setIsMaxSize] = useState(false);
    const [isWindowBarVisible,setIsWindowBarVisible] = useState(APP_WEB?false:true);
    const [isDarkMode,setIsDarkMode] = useState(props.isDark);
    const [position,setPosition] = useState<string>('')

    function themeChange(data){
        console.log('emit.....');
        // if (data == THEME_DARK){
        //     setIsDarkMode(data == THEME_DARK);
        // }else if (data == THEME_LIGHT){
        //     if (props.fromPage == 'home'){
        //         setIsDarkMode(false);
        //     }
        // }
        setIsDarkMode(data == THEME_DARK);
    }

    useEffect(() => {
        let isMaxSize:any = localStorage.getItem(KEY_IS_MAX_SIZE);
        if (isMaxSize){
            isMaxSize = isMaxSize == 'true';
        }else{
            isMaxSize = true;
        }
        setIsMaxSize(isMaxSize);

        if (!isMac()){
            ipcInvoke('check-is-max-size').then(res=>{
                setIsMaxSize(res);
            })
        }

    }, []);
    useEffect(() => {
        window.isMaxSize = isMaxSize;
        localStorage.setItem(KEY_IS_MAX_SIZE,isMaxSize?'true':'false');
    }, [isMaxSize]);

    // useEffect(() => {
    //     if (isInDraw()){
    //         setPosition('fixed')
    //     }else{
    //         setPosition('')
    //     }
    // }, [window.location.href]);

    useEffect(()=>{
        setTitle(document.title);
        // if (localStorage.getItem(SYS_CONFIG_KEY_THEME) == THEME_DARK){
        //     setIsDarkMode(true);
        // }
        setIsDarkMode(localStorage.getItem(SYS_CONFIG_KEY_THEME) == THEME_DARK);

        recvMessage(EVENT_WINDOW_BAR_VISIBLE,(msg,data)=>{
            setIsWindowBarVisible(data.data.isWindowBarVisible)
        },true)
        emitter.on(EVENT_CHANGE_THEME,themeChange)

        ipcOn('un-max-size',(event,args)=>{
            setIsMaxSize(args.isMaximized);
        });

        return ()=>{
            emitter.off(EVENT_CHANGE_THEME)
        }
    })

    const getMinsizeIcon = ()=>{
        if (isDarkMode){
            return imgPathPerfix() + "window_minsize.png"
        }
        return imgPathPerfix() + "window_minsize_black.png"
    }
    const getMaxsizeIcon = ()=>{
        if (isDarkMode){
            return imgPathPerfix() + (isMaxSize ? "window_unmaximize.png" : "window_maximize.png");
        }
        return imgPathPerfix() + (isMaxSize ? "window_unmaximize_black.png" : "window_maximize_black.png");
    }

    const getWindowClose = ()=>{
        if (isDarkMode){
            return imgPathPerfix() + "window_close.png";
        }
        return imgPathPerfix() + "window_close_black.png"
    }
    return(
        <>
            {
                !isWeb() && !isInSingleFloatWindow() &&
                <div className='title-bar' style={{
                    // position:position,
                    display: isWindowBarVisible ? 'flex' : 'none',
                    background: 'var(--title-bar-background-color)'
                }}>
                    {/*<span style={{color:'white',fontSize:'12px'}}>{title}</span>*/}

                    {
                        window.isMac &&
                        <span style={{color: isDarkMode ? 'white' : '#333333', marginLeft: '6px'}}>{props.title}</span>
                    }
                    {
                        (!window.isMac || import.meta.env.DEV) &&
                        <>
                            <div style={{position: 'absolute', left: '16px', display: 'flex', alignItems: 'center'}}>
                                <img className='img-16' style={{borderRadius: '10px'}}
                                     src={imgPathPerfix() + 'logo.png'}/>
                                <span style={{
                                    color: isDarkMode ? 'white' : '#333333',
                                    marginLeft: '6px'
                                }}>{props.title}</span>
                            </div>
                            <div style={{position: "absolute", right: '10px', display: 'flex', alignItems: 'center'}}>
                                <div className={isDarkMode ? 'div-window-minmax-dark' : 'div-window-minmax-light'}
                                     onClick={() => {
                                         ipcSend('min-size', true)
                                     }}>
                                    <img className='img-mini-small-12' src={getMinsizeIcon()}/>
                                </div>

                                <div className={isDarkMode ? 'div-window-minmax-dark' : 'div-window-minmax-light'}
                                     onClick={() => {
                                         ipcSend('max-size', true);
                                         setIsMaxSize(!isMaxSize);
                                     }}>
                                    <img className='img-mini-small-12'
                                         src={getMaxsizeIcon()}
                                    />
                                </div>

                                <div className={isDarkMode ? 'div-close-dark' : 'div-close-light' + ' mr-2'}
                                     onClick={() => {
                                         ipcSend("window-close")
                                     }}>
                                    <img className='img-mini-small-12' src={getWindowClose()}
                                    />
                                </div>

                            </div>
                        </>
                    }
                </div>
            }
        </>
    )
});

export default TitleBar;